<template>
  <basic-container>
<el-form :model="selectForm" ref="ruleForm" label-width="80px" >
         <el-row :gutter="24">
             
            <el-col :span="12">
                <el-form-item label="维修日期">
                     <el-date-picker
                                  style="width: 100%"
                                  clearable
                                  v-model="selectForm.timeRange"
                                  value-format="yyyy-MM-dd"
                                  type="daterange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  >
                              </el-date-picker>
                </el-form-item>
            </el-col>
            
            <el-col :span="12">
                <div style="float:right">
                              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small"> 搜索 </el-button>
                              <el-button @click="searchClear" icon="el-icon-delete" size="small"> 清空 </el-button>
                </div>
            </el-col>

          
          </el-row>
    </el-form>
    <avue-crud
           
            :option="option"
            :table-loading="loading"
            :data="deviceMaintenanceRecordList"
            :page.sync="page"
            v-model="selectForm"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @search-reset="searchReset"
            @selection-change="selectionChange"
            @size-change="sizeChange"
            @refresh-change="onLoad">
      <template slot="menuLeft">
         <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord"> 新 增</el-button>
      </template>
      <template slot="amount" slot-scope="scope">
              <div class="money"><span>{{tool.money_format_allowvoid(scope.row.amount)  }}</span></div>
      </template>
       <template slot-scope="scope" slot="menu">
         <el-button
                type="text"
                size="small"
                icon="el-icon-tickets"
                @click="checkRecord(scope.row.id)"
                >查看
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                @click="editRecord(scope.row.id)"
                >编辑
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                @click="removeRecord(scope.row.id)"
                >删除
            </el-button>
       </template>
    </avue-crud>

     <hr-dialog
          :title="dialogTitle"
          v-if="addFlag"
          :visible.sync="addFlag"
        
          width="80%"
          :handleClose="handleClose">
          <template slot="body">
            <addKeepRecord :row="row" :isAdd='true' :projectId="row.projectId"  :isEdit='true' :form='form' @cancelOperate="cancelOperate" @submitOver='submitOver'></addKeepRecord>
          </template>
          
        </hr-dialog>

         <hr-dialog
          :title="dialogTitle"
          v-if="watchFlag"
          :visible.sync="watchFlag"
         
          width="80%"
          :handleClose="handleClose">
           <template slot="body">
             <addKeepRecord  :projectId="row.projectId"  :isEdit='false' :form='form' @cancelOperate="cancelOperate" @submitOver='submitOver'></addKeepRecord>
          </template>
         
        </hr-dialog>
        <hr-dialog
          :title="dialogTitle"
          v-if="editFlag"
          :visible.sync="editFlag"
      
          width="80%"
          :handleClose="handleClose">
           <template slot="body">
             <addKeepRecord  :projectId="row.projectId"  model="update" :isEdit='true' :form='form' @cancelOperate="cancelOperate" @submitOver='submitOver'></addKeepRecord>
          </template>
         
        </hr-dialog>
  </basic-container>
</template>

<script>
  import { deviceKeepRecordList,deleteKeepDetail} from '@/api/crmedical/device/deviceKeepRecord';
  import addKeepRecord from "@/components/device/device/maintenanceRecoderAdd"
  import { getkeepStandard,updateKeepDetail} from '@/api/crmedical/device/deviceKeepRecord';
  import { getDeviceKeepRecord} from '@/api/crmedical/device/addDevice';
  export default {
    props:["row"],
    components:{
      addKeepRecord
    },
    data() {
      return {
        dialogTitle:'',
        addFlag:false,
        watchFlag:false,
        editFlag:false,
       deviceMaintenanceRecordList:[],
        selectForm:{
           timeRange:[]
        },
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
       form:{},
        option: {
         index: true,
        // selection: true,
        // reserveSelection:true,
        indexLabel: '序号',
        page: true,
        align: 'left',
        menuAlign: 'center',
        addBtn:false,
        editBtn: false,
        delBtn: false,
        border:true,
        height:'auto',
          column: [
            {
              label: "设备编号",
              prop: "code",
            },
            
            {
              label: "设备名称",
              prop: "deviceName",
            },
            {
              label: "合同编号",
              prop: "contractCode",
            },
            {
              label: "合同名称",
              prop: "contractName",
            },
            {
              label: "维保单位",
              prop: "partnerName",
            },
            {
               label: "维保人",
              prop: "realUpkeepManName",
            },
            
            {
              label: "维保时间",
              prop: "realUpkeepTime",
              type:'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
            
            {
               label: "维保金额",
               prop: "amount",
               slot:true,
               align:'right'
            },
            {
              label: "备注",
              prop: "description",
            },
            {
              label:'工单编号',
              prop:'orderCode',
              width:'160'
            },
          ],
        },
        
      };
    },
    created(){
      console.log("row",this.row.id)
      this.selectForm.deviceId = this.row.id
      this.selectForm.projectId = this.row.projectId
      
      console.log(" this.selectForm.deviceId", this.selectForm.deviceId)
    },
    mounted(){
      this.option.height = this.bodyHeight - 379;
    },
    methods: {
      cancelOperate(){
        this.handleClose()
      },
      submitOver(){
         this.handleClose()
         this.searchRecord()
      },
       searchRecord(){
           this.page.currentPage = 1
          if(this.selectForm.timeRange&&this.selectForm.timeRange.length>0){
                this.selectForm.startTime = this.dayjs(this.selectForm.timeRange[0]).format('YYYY-MM-DD 00:00:00')
                this.selectForm.endTime = this.dayjs(this.selectForm.timeRange[1]).format('YYYY-MM-DD 23:59:59') 
            }else{
                this.selectForm.timeRange = []
                this.selectForm.startTime = ''
                  this.selectForm.endTime = ''
            }
             this.onLoad()
        },
        searchClear(){
          this.$set(this.selectForm,'timeRange',[])
        },
       removeRecord(id){
          this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {    
             deleteKeepDetail(id).then(()=>{
              this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.onLoad()
            })
        })
            
        },
      handleClose(){
        this.addFlag = false
        this.watchFlag = false
        this.editFlag = false
      },
      addRecord(){ 
        this.dialogTitle = "新增"
        this.form = {}
        this.addFlag = true
      },
      editRecord(id){
        this.dialogTitle = '编辑'
        this.form = {}
        getDeviceKeepRecord({id}).then(({data})=>{
          this.form = data
          this.editFlag = true
        })
      },
      checkRecord(id){
        this.dialogTitle = '查看'
        this.form = {}
        getDeviceKeepRecord({id}).then(({data})=>{
          this.form = data
          this.watchFlag = true
        })
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
     
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        deviceKeepRecordList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.selectForm)
        ).then(({data}) => {
          this.page.total = data.total;
          this.deviceMaintenanceRecordList = data.records;
          this.loading = false;
          
        });
      }
    }
  };
</script>

<style scoped>
  .money{
  text-align: right;
}
</style>
